const func = () => {
	var 
		// $ecom = $('.ecomz'), 
		// $ecomMini = $('.ecom-miniz'), 
		// $mod097 = $('[data-kd-id="097"]'),
		// $mod045 = $('[data-kd-id="045"]'),
		// $comp096 = $('[data-kd-id="096"]'),
		// $mod066 =$('[data-kd-id="066"]'),
		// $mod032 = $('[data-kd-id="032"]'),
		$talkAdvisor = $('[data-kd-id="talkAdvisor"]');
		// path = window.location.pathname.substring(1),
		// run = false;

	// [$ecom,$ecomMini,$mod097,$mod045,$comp096,$mod066,$mod032].forEach(element => {
	// 	if (element.length) {
	// 		run = true;
	// 	}
	// });

	if ($talkAdvisor.length){
		$('header').remove()
	}

	// function checkAnon($el) {
	// 	if ($el.attr('data-anon-ok') == 'true') {
	// 		$el.removeClass('d-none');
	// 		return true;
	// 	}
	// 	return false;
	// }

	// if (run) {

	// 	var $els = [
	// 		$ecom,
	// 		$ecomMini.find('form'),
	// 		$mod097.find('["data-multiadd-total"]'),
	// 		$mod045.find('form'),
	// 		$comp096.find('.card-text.price'),
	// 		$mod066.find('.price-display'),
	// 		$mod032.find('.price-display')
	// 	];
	// 	$.ajax({
	// 		url: '/api/dsd/user-country',
	// 		dataType: 'json',
	// 		error: function(e) {
	// 			console.log(e);
	// 		}
	// 	}).done(function(data) {
	// 		if (data.loggedIn && data.customer && data.hasAddress) {
	// 			$els.forEach(element => {
	// 				element.removeClass('d-none');
	// 			});
	// 		} else  {
	// 			if ($ecom.attr('data-anon-ok') == 'true') {
	// 				$ecom.removeClass('d-none');
	// 				$ecomMini.find('from').removeClass('d-none');
	// 			} else {
	// 				if (data.loggedIn) {
	// 					$ecom.before('<div class="mb-5"><span class="text-muted small">Please provide a registered primary clinic address to purchase this product.</span><br><a href="/account/addresses/edit" class="btn btn-success btn-lg mb-5 mt-3 w-100"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Add Your Clinic Address</a></div>');
	// 					$ecomMini.find('.purchase').html('<a href="/account/addresses/edit" class="btn btn-action"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Add Your Clinic Address</a>');
	// 				} else {
	// 					$ecom.before('<div class="mb-5"><a href="/account/signin?next='+path+'" class="btn btn-success btn-lg mb-5 w-100"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-user"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> Sign In To Purchase</a></div>');
	// 					$ecomMini.find('.purchase').html('<a href="/account/signin?next='+path+'" class="btn btn-action"><svg xmlns="http://www.w3.org/2000/svg" class="mr-1 mt-n1 d-none d-lg-inline" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path></svg> Sign In To Purchase</a>');
	// 				}
	// 			}
	// 			$mod066.find('.price-display[data-anon-ok="true"]').removeClass('d-none');
	// 			$mod032.find('.price-display[data-anon-ok="true"]').removeClass('d-none');
	// 			$mod097.find('["data-multiadd-total"][data-anon-ok="true"]').removeClass('d-none');
	// 			$mod045.find('form[data-anon-ok="true"]').removeClass('d-none');
	// 			$comp096.find('.card-text.price[data-anon-ok="true"]').removeClass('d-none');
				
	// 		}
			
	// 	});
	// }
};

export default func;
